export const buildQuery = (params = {}) => {
  const sp = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value === null || value === undefined) return;
    if (value === "") return;

    if (Array.isArray(value)) {
      value.filter(Boolean).forEach((v) => sp.append(key, String(v)));
      return;
    }

    sp.set(key, String(value));
  });

  const qs = sp.toString();
  return qs ? `?${qs}` : "";
};
